export default "__VITE_ASSET__URmBUsAP__"